<div class="grid-container">
<div class="content content-with-elevation">

  <div class="grid-y" *ngIf="!emailSent">
    <p>Please provide your email address and password. An email will be sent to you.</p>
    <form [formGroup]="recoverUserNameForm" (ngSubmit)="onSubmit()" novalidate>
      <common-alerts [error]="errorMessages"></common-alerts>
      <div class="grid-y">
        <div class="grid-x ">
          <div class="cell large-2 medium-4 small-12">
            <label class="label-center">Email Address</label>
          </div>
          <div class="large-4 medium-8 small-12">
            <input formControlName="email" placeholder="Email"
                   class="input-group-custom" required>
          </div>
        </div>
        <div class="grid-x ">
          <div class="cell large-2 medium-4 small-12">
            <label class="label-center">Password</label>
          </div>
          <div class="large-4 medium-8 small-12">
            <input formControlName="password" placeholder="Password"
                   class="input-group-custom" required type="password">
          </div>
        </div>
        <div class="grid-x ">
          <div class="cell large-2 medium-4 small-12">
          </div>
          <div class="large-4 medium-8 small-12">
            <div class="button-placement-right">
              <button class="iana-button" type="submit" [disabled]="!recoverUserNameForm.valid">Proceed</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="grid-y" *ngIf="emailSent">
    <p>Please complete the instructions in the email we sent.</p>
    <p>Close this page, or go back to the <a routerLink="/home">login</a> page.</p>
  </div>
</div>
</div>
